"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find-index");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _lastMileDelivery = require("@/mixins/last-mile-delivery/last-mile-delivery");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDOrderFilterAutoAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDOrderFilterAutoAssignComponent, _Mixins);

  var _super = _createSuper(LMDOrderFilterAutoAssignComponent);

  function LMDOrderFilterAutoAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDOrderFilterAutoAssignComponent);
    _this = _super.apply(this, arguments);
    _this.filters = [{
      'key': 'pickup'
    }, {
      'key': 'dropoff'
    }];
    _this.zones = [];
    _this.zone = null;
    _this.filterSearch = [{
      'key': 'zone'
    }, {
      'key': 'projectCode'
    }, {
      'key': 'customerCode'
    }, {
      'key': 'shipmentReference'
    }, {
      'key': 'commodityType'
    }, {
      'key': 'serviceType'
    }, {
      'key': 'serviceName'
    }, {
      'key': 'serviceProviderName'
    }, // { 'key': 'pickStartTime' },
    {
      'key': 'pickCompName'
    }, // { 'key': 'waypoints.waypointType:P|waypoints.district' },
    // { 'key': 'waypoints.waypointType:P|waypoints.address1' },
    // { 'key': 'dropStartTime' },
    {
      'key': 'dropCompName'
    }, // { 'key': 'waypoints.waypointType:D|waypoints.district' },
    // { 'key': 'waypoints.waypointType:D|waypoints.address1' },
    {
      'key': 'remarks'
    }, {
      'key': 'itemInfo'
    }];
    _this.queryType = 'AND';
    _this.selectValue = 'projectCode';
    _this.inputValue = null;
    return _this;
  }

  (0, _createClass2.default)(LMDOrderFilterAutoAssignComponent, [{
    key: "created",
    value: function created() {
      this.$locationType = this.$defaultLocationType;
      this.$searchType = 'fuzzySearch';
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.routeAPI.getAllZones();

              case 2:
                res = _context.sent;
                data = this.helper.get(res, 'data', []);
                this.zones = data.length > 0 ? [''].concat((0, _toConsumableArray2.default)(data.map(function (zone) {
                  return zone['code'];
                }))) : [];

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "onFilterChanges",
    value: function onFilterChanges(type) {
      this.$selectedLocation = '';
      this.$unassignedOrders = [];
      this.$getOrderLocationLists({
        'locationType': type,
        'startTime': this.$startDate,
        'endTime': this.$endDate
      });
    }
  }, {
    key: "onLocationChanges",
    value: function () {
      var _onLocationChanges = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(location) {
        var key, label, filters;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                key = 'waypoints.waypointType:P|waypoints.address1';
                label = 'pickBuilding';

                if (this.$locationType === 'dropoff') {
                  key = 'waypoints.waypointType:D|waypoints.address1';
                  label = 'dropBuilding';
                }

                filters = this.$orderFilters.filter(function (item) {
                  return item['label'] !== 'pickBuilding' && item['label'] !== 'dropBuilding';
                });
                filters.push({
                  'exactValue': true,
                  'key': key,
                  'label': label,
                  'value': location
                });
                this.$orderFilters = filters;
                _context2.next = 8;
                return this.$getUnassignedOrders();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onLocationChanges(_x) {
        return _onLocationChanges.apply(this, arguments);
      }

      return onLocationChanges;
    }() // onZoneChanges(zone) {
    //   let filters = [
    //     ...this.$orderFilters,
    //     {
    //       'key': 'zone',
    //       'label': 'zone',
    //       'value': zone
    //     }
    //   ];
    //   if (zone === '') {
    //     filters = filters.filter(item => item['key'] !== 'zone');
    //   }
    //   this.$orderFilters = filters;
    //   this.$getUnassignedOrders();
    // }

  }, {
    key: "addFilter",
    value: function addFilter(str) {
      if (/\S/.test(str) && this.helper.isNotEmpty(this.$selectedLocation)) {
        var index = this.helper.findIndex(this.$orderFilters, {
          'key': this.selectValue,
          'value': str
        });

        if (index === -1) {
          var newFilter = {
            queryType: this.queryType,
            key: this.selectValue,
            label: this.mapLabel(this.selectValue),
            value: str
          };
          this.$orderFilters = [].concat((0, _toConsumableArray2.default)(this.$orderFilters), [newFilter]);
        }
      }

      this.inputValue = '';
    }
  }, {
    key: "handleFilterInput",
    value: function handleFilterInput(str) {
      var _this2 = this;

      var match = /\r|\n/.exec(str);

      if (match) {
        var strings = str.split('\n').filter(function (s) {
          return !_this2.helper.isUndefined(s);
        });
        strings.forEach(function (s) {
          _this2.addFilter(s);
        });
      }
    }
  }, {
    key: "mapLabel",
    value: function mapLabel(key) {
      var label = key;

      switch (key) {
        case 'waypoints.waypointType:P|waypoints.district':
          label = 'pickDistrict';
          break;

        case 'waypoints.waypointType:P|waypoints.address1':
          label = 'pickBuilding';
          break;

        case 'waypoints.waypointType:D|waypoints.district':
          label = 'dropDistrict';
          break;

        case 'waypoints.waypointType:D|waypoints.address1':
          label = 'dropBuilding';
          break;
      }

      return label;
    }
  }]);
  return LMDOrderFilterAutoAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_lastMileDelivery.LastMileDeliveryMixin));

LMDOrderFilterAutoAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDOrderFilterAutoAssignComponent',
  components: {
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-tag': _elementUi.Tag,
    'el-input': _elementUi.Input,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-tooltip': _elementUi.Tooltip
  }
})], LMDOrderFilterAutoAssignComponent);
var _default = LMDOrderFilterAutoAssignComponent;
exports.default = _default;